import { render, staticRenderFns } from "./direction-selector.vue?vue&type=template&id=3f05dcb8&scoped=true"
import script from "./direction-selector.vue?vue&type=script&lang=js"
export * from "./direction-selector.vue?vue&type=script&lang=js"
import style0 from "./direction-selector.vue?vue&type=style&index=0&id=3f05dcb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f05dcb8",
  null
  
)

export default component.exports